var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Snackbar, IconButton, withStyles, Icon } from '@material-ui/core';
import * as Actions from '../../store/actions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
var styles = function (theme) { return ({
    root: {
        position: 'absolute',
    },
    close: {},
}); };
var Message = function (props) { return (React.createElement(Snackbar, __assign({}, props.options, { open: props.state, onClose: props.hideMessage, classes: {
        root: props.classes.root,
    }, action: [
        React.createElement(IconButton, { id: "close-message-btn", key: "close", "aria-label": "Close", color: "inherit", className: props.classes.close, onClick: props.hideMessage },
            React.createElement(Icon, null, "close")),
    ] }))); };
function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        hideMessage: Actions.hideMessage,
    }, dispatch);
}
function mapStateToProps(_a) {
    var fuse = _a.fuse;
    return {
        state: fuse.message.state,
        options: fuse.message.options,
    };
}
// @ts-ignore
export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(Message));



//////////////////
// WEBPACK FOOTER
// ./src/theme/components/Message.tsx
// module id = 598
// module chunks = 81